import { call, cps, select } from 'redux-saga/effects';
import { getMinutesPerSegment, getTimelineLabelWidth } from 'selectors/monitoringSelectors';
import { CameraMessage, CellIndex } from 'types';
import { TimelineWorkerPool, timelineWorkerPoolFactory } from 'workers';

let timelineWorkerPool: TimelineWorkerPool | null = null;

export function* generateTimelineSaga(cellIndex: CellIndex, utcDate: Date, messages: readonly CameraMessage[]) {
    // Would like to avoid ever doing DOM access at all, let alone outside of React code.
    // However, the cleanest way to get the width we need is to query the DOM directly.
    const domElement = yield call([ document, 'getElementById' ], `timeline${cellIndex}`);
    const displayWidth = domElement ? domElement.clientWidth : 665;

    const minutesPerSegment = yield select(getMinutesPerSegment, { cellIndex });
    const labelWidth = yield select(getTimelineLabelWidth);

    const utcToday = new Date().setUTCHours(0, 0, 0, 0);

    // TODO: look up timezone information from store
    const minutesInDay = 1440; // TODO: don't hardcode this

    // Put together a work request for a worker thread to process the camera messages
    const work = {
        cellIndex,
        messages,
        autoTrackingPolicies: {}, // TODO: pull from store
        utcDate: utcDate.getTime(),
        utcToday,
        minutesInDay,
        displayWidth,
        labelWidth,
        minutesPerSegment,
    };

    if (!timelineWorkerPool) {
        timelineWorkerPool = yield call(timelineWorkerPoolFactory);
    }

    // Returns the timeline (or throws an Error if it failed)
    if (timelineWorkerPool) {
        return yield cps([ timelineWorkerPool, 'queueWork' ], work);
    }
}


// WEBPACK FOOTER //
// ./src/sagas/monitoring/generateTimelineSaga.ts